export const SERVER_URL = process.env.API_URL;

export const EKYC_GET_PUBLIC_KEY = `${SERVER_URL}/kyc/api/v1/ekyc/get_public_key`;

export const EKYC_GENERATE_OTP = `${SERVER_URL}/kyc/api/v1/ekyc/generate_otp`;

export const EKYC_VERIFY_OTP = `${SERVER_URL}/kyc/api/v1/ekyc/verify_otp`;

export const EKYC_STATUS = `${SERVER_URL}/kyc/api/v1/ekyc/status`;

export const EKYC_REDIRECT = `${SERVER_URL}/kyc/api/v1/ekyc/redirect`;

export const GET_USER_TOKEN_DETAILS = `${SERVER_URL}/usrmgmt`;

export const USER_LANG_UPDATE = `${SERVER_URL}/usrmgmt/user_management/users/preference`;

export const USER_TOKEN_UPDATE = `${SERVER_URL}/usrmgmt/user_management/token/update`;
